/**
 * 应用中心团购模块
 */
export const ApplyGoodsGroupArr = [
  {
    path: "GoodsGroup/:id",
    name: "GoodsGroup/:id",
    redirect: "/apply/GoodsGroup/:id/index",
    meta: {
      title: "团购"
    },
    component: () => import("@/views/sidebar/itemFrame.vue"),
    children: [
      {
        path: "index",
        name: "index",
        meta: {
          title: "首页"
        },
        component: () => import("@/views/apply/GoodsGroup/index.vue")
      },
      // {
      //   path: "GroupManage",
      //   name: "GroupManage",
      //   meta: {
      //     title: "团购管理"
      //   },
      //   component: () => import("@/views/apply/GoodsGroup/GroupManage.vue")
      // },
      {
        path: "shopList",
        name: "shopList",
        meta: {
          title: "店铺列表"
        },
        component: () => import("@/views/apply/GoodsGroup/shopList.vue")
      },
      {
        path: "serviceSupport",
        name: "serviceSupport",
        meta: {
          title: "服务支持"
        },
        component: () => import("@/views/apply/GoodsGroup/serviceSupport.vue")
      },
      {
        path: "paySupport",
        name: "paySupport",
        meta: {
          title: "支付支持"
        },
        component: () => import("@/views/apply/GoodsGroup/paySupport.vue")
      },
      {
        path: "rank",
        name: "rank",
        meta: {
          title: "排行榜设置"
        },
        component: () => import("@/views/apply/GoodsGroup/rank.vue")
      },
      {
        path: "verification",
        name: "verification",
        meta: {
          title: "验消管理"
        },
        component: () => import("@/views/apply/GoodsGroup/verification.vue")
      },
      {
        path: "createGroup",
        name: "createGroup",
        meta: {
          title: "团购产品"
        },
        component: () => import("@/views/apply/GoodsGroup/createGroup.vue")
      },
      {
        path: "groupProduct",
        name: "groupProduct",
        meta: {
          title: "团购产品"
        },
        component: () => import("@/views/apply/GoodsGroup/groupProduct.vue")
      },
      // {
      //   path: "createProduct",
      //   name: "createProduct",
      //   meta: {
      //     title: "添加产品"
      //   },
      //   component: () => import("@/views/apply/GoodsGroup/createProduct.vue")
      // },
      {
        path: "checkActivity",
        name: "checkActivity",
        meta: {
          title: "买单活动"
        },
        component: () => import("@/views/apply/GoodsGroup/checkActivity.vue")
      },
      {
        path: "createcheckAct",
        name: "createcheckAct",
        meta: {
          title: "买单活动"
        },
        component: () => import("@/views/apply/GoodsGroup/createcheckAct.vue")
      },
      {
        path: "LibraryOfGoods",
        name: "LibraryOfGoods",
        meta: {
          title: "商品库"
        },
        component: () => import("@/views/apply/GoodsGroup/LibraryOfGoods.vue")
      },
      {
        path: "createshopFood",
        name: "createshopFood",
        meta: {
          title: "添加商品"
        },
        component: () => import("@/views/apply/GoodsGroup/createshopFood.vue")
      },
      {
        path: "groupClass",
        name: "groupClass",
        meta: {
          title: "团购分类"
        },
        component: () => import("@/views/apply/GoodsGroup/groupClass.vue")
      },
      {
        path: "groupOrder",
        name: "groupOrder",
        meta: {
          title: "团购订单"
        },
        component: () => import("@/views/apply/GoodsGroup/groupOrder.vue")
      },
      {
        path: "userLabel",
        name: "userLabel",
        meta: {
          title: "用户端标签"
        },
        component: () => import("@/views/apply/GoodsGroup/userLabel.vue")
      },
      {
        path: "shopLabel",
        name: "shopLabel",
        meta: {
          title: "商品库标签"
        },
        component: () => import("@/views/apply/GoodsGroup/shopLabel.vue")
      },
      {
        path: "evaluateList",
        name: "evaluateList",
        meta: {
          title: "评价管理"
        },
        component: () => import("@/views/apply/GoodsGroup/evaluateList.vue")
      },
      {
        path: "addComment",
        name: "addComment",
        meta: {
          title: "评价管理"
        },
        component: () => import("@/views/apply/GoodsGroup/addComment.vue")
      }
    ]
  }
];
